export const IconGrc20: {
  name: 'icon_grc_20-7f892dab7e30'
} = {
  name: 'icon_grc_20-7f892dab7e30'
}
